/**
 * @generated SignedSource<<9163ddf91179a558c219f33cabe7a0a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueTimelineMultipleViewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TimelineItemsViewer">;
  readonly " $fragmentType": "IssueTimelineMultipleViewer";
};
export type IssueTimelineMultipleViewer$key = {
  readonly " $data"?: IssueTimelineMultipleViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineMultipleViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTimelineMultipleViewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimelineItemsViewer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b4349535e44a0f460e536f72773044f0";

export default node;
